import { Component } from "../base/Component";
import { ensureElement, createElement, handlePrice } from "../../utils/utils";
export class Basket extends Component {
    constructor(container, events) {
        super(container);
        this.events = events;
        this._list = ensureElement('.basket__list', this.container);
        this._total = this.container.querySelector('.basket__price');
        this._button = this.container.querySelector('.basket__button');
        if (this._button) {
            this._button.addEventListener('click', () => {
                events.emit('basket:go-to-order-step');
            });
        }
        this.items = [];
    }
    set items(items) {
        if (items.length) {
            this._list.replaceChildren(...items);
        }
        else {
            this._list.replaceChildren(createElement('p', {
                textContent: 'Корзина пуста'
            }));
        }
    }
    set selected(hasItems) {
        this.setDisabled(this._button, !hasItems);
    }
    set total(total) {
        this.setText(this._total, handlePrice(total) + ' синапсов');
    }
}
